var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ProductCellFieldProduct',_vm._g(_vm._b({scopedSlots:_vm._u([{key:"previewDialog",fn:function(ref){
    var dialog = ref.dialog;
    var manageDialog = ref.manageDialog;
    var selectRefFields = ref.selectRefFields;
    var item = ref.item;
    var columnTitle = ref.columnTitle;
return [_c('AddingEqual',{attrs:{"dialog":dialog,"item":item,"column-title":columnTitle},on:{"manageDialog":manageDialog,"selectFields":selectRefFields}})]}}])},'ProductCellFieldProduct',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }